import { render, staticRenderFns } from "./BankDetailsInfo.vue?vue&type=template&id=71f83418&scoped=true"
import script from "./BankDetailsInfo.vue?vue&type=script&lang=js"
export * from "./BankDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsInfo.vue?vue&type=style&index=0&id=71f83418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f83418",
  null
  
)

export default component.exports